import { motion } from "framer-motion";
import { SITE } from "../data/site";

const PORTRAIT =
  "https://customer-assets.emergentagent.com/job_web-dev-showcase-54/artifacts/bcdimvcn_4c645e61-6d1b-4de6-ad3c-02c045ddfe49.png";

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 md:py-40 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="flex items-center gap-3 mb-16 md:mb-24"
        >
          <span className="w-10 h-px bg-[#f5e6d3]" />
          <span className="font-display text-xs uppercase tracking-[0.3em] text-[#f5e6d3]">
            About — 001
          </span>
        </motion.div>

        <div className="grid md:grid-cols-12 gap-10 md:gap-16">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9 }}
            className="md:col-span-5 relative"
          >
            <div className="relative aspect-[4/5] overflow-hidden bg-zinc-900">
              <img
                src={PORTRAIT}
                alt="Mohamad Hama portrait"
                className="w-full h-full object-cover grayscale hover:grayscale-0 transition-all duration-700"
              />
            </div>
            <div className="absolute -bottom-6 -right-4 md:-right-12 max-w-[260px] bg-black/70 backdrop-blur-xl border border-white/10 p-5">
              <div className="font-display text-xs uppercase tracking-[0.2em] text-[#f5e6d3] mb-2">
                Previously at
              </div>
              <div className="font-display text-xl uppercase leading-tight">
                {SITE.companies.join(" · ")}
              </div>
              <div className="font-editorial italic text-sm text-zinc-400 mt-2">
                Now independent.
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9, delay: 0.1 }}
            className="md:col-span-7 md:pl-8"
          >
            <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl uppercase leading-[0.95] tracking-tight">
              I build websites
              <br />
              <span className="font-editorial italic font-light text-[#f5e6d3] normal-case lowercase">
                that earn their keep.
              </span>
            </h2>

            <div className="mt-10 space-y-6 font-body text-base md:text-lg text-zinc-300 leading-relaxed max-w-xl">
              <p>
                I'm Mohamad — a freelance web developer based in {SITE.location.split(",")[0]},
                Sweden. For the past {SITE.experience}, I've been turning ideas
                from small businesses, studios and non-profits into sites that
                people actually use.
              </p>
              <p>
                I've worked with teams at{" "}
                <span className="text-white font-medium">Alkompis</span> and{" "}
                <span className="text-white font-medium">NovaCode</span> before
                going independent. Today I work directly with founders and
                owners — restaurants, beauty studios, driving schools,
                multilingual associations — to ship work that feels carefully
                made, not assembled from a template.
              </p>
            </div>

            <div className="mt-12 grid grid-cols-3 gap-6 max-w-md">
              {[
                { k: "+3", v: "Years building" },
                { k: "10+", v: "Sites shipped" },
                { k: "2", v: "Teams led with" },
              ].map((s) => (
                <div key={s.v} className="border-t border-white/10 pt-4">
                  <div className="font-display text-3xl md:text-4xl">
                    {s.k}
                  </div>
                  <div className="font-body text-xs uppercase tracking-wider text-zinc-500 mt-1">
                    {s.v}
                  </div>
                </div>
              ))}
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
